import { Length, ModelBase, NormalLength, Pattern, Property, VeryLongLength, VeryShortLength } from '@skylab-shared/core';
import { OrdersValidationPatterns } from './order-violation-patterns';

export class OrderDeliveryAddressModel extends ModelBase {
	@Property()
	@Length({ max: VeryLongLength }, 'data-model.orders.address.validation.line1.length')
	@Pattern({pattern: OrdersValidationPatterns.Address}, 'data-model.orders.address.validation.line2.pattern')
	public line1: string;

	@Property(String, {nullable: true})
	@Pattern({pattern: OrdersValidationPatterns.Address }, 'data-model.orders.address.validation.line2.lengpatternth')
	@Length({ max: VeryLongLength }, 'data-model.orders.address.validation.line2.length')
	public line2: string | null;

	@Property()
	@Length({ max: NormalLength }, 'data-model.orders.address.validation.city.length')
	@Pattern({pattern: OrdersValidationPatterns.City }, 'data-model.orders.address.validation.city.pattern')
	public city: string;

	@Length({ max: VeryShortLength }, 'data-model.orders.address.validation.zip-code.length')
	@Property()
	public zipCode: string;

    @Property(String, { nullable: true })
    public countryExternalId: string | null;
}
